import axios from 'axios';

class MitAppsService {
  constructor() {

  }

  getNewFeatureToggle(){
    return {
      name:'test-feature',
      enabled:false
    }
  }
  getNewDefaultApp(){
    return {
      appId: '',
      enabled: false,
      accessUsers: {
        0:['*'],
        10:['*'],
        20:['*'],
        30:['*']
      },
      accessGroups: {
        0:[],
        10:[],
        20:[],
        30:[]
      },
      featureToggle:[],
      apiToken:''
    };
  }

  updateQueryStringParameter(uri, key, value) {
    if(typeof(value) === "undefined" || value === null) return uri;//if not defined ignore

    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  getApiToken(appId) {
    return new Promise ((resolve, reject) => {
      let url = '/api/v1/apps/api_token/'+appId;

      axios.get(url)
        .then((response) => {
            return resolve(response.data.apiToken);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  getApps(page, pageSize, filters) {
    return new Promise ((resolve, reject) => {
      let url = '/api/v1/apps/';

      filters = filters || {};
      url = this.updateQueryStringParameter(url, 'page', page);
      url = this.updateQueryStringParameter(url, 'pageSize', pageSize);
      url = this.updateQueryStringParameter(url, 'appId', filters.appId);

      axios.get(url)
        .then((response) => {
            response.data.total = parseInt(response.data.total);//convert total to a number
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  saveApp(user) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/apps/', user)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

}

export default new MitAppsService();
